module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-1_BG-9d9179b2f2327249c0ab8e3bf7ba6f4d.svg";